import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Observable } from 'rxjs';
import { HCPClass } from '../../lookups/models/hcpclass.model';


@Injectable({
  providedIn: 'root'
})
export class HCPClassApiService {

  constructor(protected readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }


  getAll(): Observable<HCPClass[]> {
    return this.http.get<HCPClass[]>(`${this.configurations.apiAddress}/api/hcpClass/getAll`);
  }


}
